// ===========================================
// useAdminTeacherView Hook
// ===========================================
// Hook to access admin/teacher view context

import { useContext } from 'react';
import { AdminTeacherViewContext } from './AdminTeacherViewContext.types';

export function useAdminTeacherView() {
  const context = useContext(AdminTeacherViewContext);
  if (context === undefined) {
    throw new Error('useAdminTeacherView must be used within an AdminTeacherViewProvider');
  }
  return context;
}
